module.exports = __webpack_public_path__ + "static/media/YF89_5.35d9bacb.jpg";